import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpContext} from "@angular/common/http";
import {Observable} from "rxjs";
import {UserData} from "../../generated-model/model";
import {environment} from "../../environments/environment";
import {IGNORE_LOADING} from "../interceptors/loading_interceptor";
import {IGNORE_400_ERROR} from "../shared/commons/interceptor/http400-interceptor";
import {IGNORE_5XX_ERROR} from "../shared/commons/interceptor/http5xx-interceptor";

@Injectable({providedIn: "root"})
export class UserDataResource {
  http = inject(HttpClient);

  getUserData(): Observable<UserData> {
    const httpContext = new HttpContext();
    httpContext.set(IGNORE_LOADING, true)
    httpContext.set(IGNORE_400_ERROR, true);
    httpContext.set(IGNORE_5XX_ERROR, true);
    return this.http.get<UserData>(`${environment.serverUrl}/public/api/user-data`, {context: httpContext});
  }

}
